import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=ebc6193e&scoped=true"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"
import style0 from "./UserActivities.vue?vue&type=style&index=0&id=ebc6193e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc6193e",
  null
  
)

export default component.exports